<template>
    <div class="page">
        <div class="topView">
            <div class="topViewL">
                <div>退货申请详情</div>
            </div>
            <div class="topViewR">
                <el-button type="warning" v-if="detailData.state == 1" plain @click="handelTurn">驳回</el-button>
                <el-button type="warning" v-if="detailData.state == 1" plain @click="handelConfirmClick">确认退货</el-button>
                <el-button type="warning" v-if="detailData.state == 3" plain @click="handelInput">确认录入</el-button>
                <el-button type="warning" v-if="detailData.state == 4" plain @click="handelRefund">退款</el-button>
                <el-button type="warning" v-if="detailData.state == 1 || detailData.state == 2 || detailData.state == 3"
                    plain @click="handelCancel">取消</el-button>
                <el-button type="warning" plain @click="$router.back();">返回</el-button>
            </div>
        </div>
        <div class="detailView">
            <div class="detailViewName">退货申请信息</div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>退货单号：</div>
                    <div>{{ detailData.no }}</div>
                </div>
                <div class="detailCol">
                    <div>订单编号：</div>
                    <div>{{ detailData.order_id }}</div>
                </div>
                <div class="detailCol">
                    <div>申请日期：</div>
                    <div>{{ $public.FTime(detailData.create_time, "YYYY-MM-DD HH:mm:ss") }}</div>
                </div>
                <div class="detailCol">
                    <div>申请状态：</div>
                    <div>{{ $public.formatOrderReturnState(detailData.state) }}</div>
                </div>
            </div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>用户：</div>
                    <div>{{ user_info.nick_name }}</div>
                </div>
                <div class="detailCol">
                    <div>电话：</div>
                    <div>{{ user_info.user_mobile }}</div>
                </div>
                <div class="detailCol">
                    <div>结算方式：</div>
                    <template v-if="detailData.pay_info != null">
                        <span v-for="(item, index) in detailData.pay_info.pay_list" :key="index">
                            <template v-if="item.pay_type == 1">支付宝</template>
                            <template v-if="item.pay_type == 2">微信</template>
                            <template v-if="item.pay_type == 7">余额</template>
                            <template v-if="item.pay_type == 9">积分</template>
                            <template v-if="item.pay_type == 17">拉卡拉</template>
                        </span>
                    </template>
                </div>
                <div class="detailCol">
                    <div>退款金额：</div>
                    <div v-if="!type">{{ detailData.total_price }}</div>
                    <el-input v-if="type" v-model="detailData.total_price" placeholder="请输入金额"></el-input>
                </div>
            </div>
        </div>
        <div class="tableWrap">
            <div class="tableTitle" >
                <div class="tableTitleL">录入条码信息</div>

                <div class="tableTitleR">
                    <el-button type="warning" size="small" v-if="detailData.state== 1" @click="handleEdit(1)">编辑</el-button>
                    <el-input v-if="detailData.state == 3" v-model="code" placeholder="请输入条码" style="margin-right: 10px;" 
                        @keyup.enter.native="handelInputClick"></el-input>
                    <el-button type="warning" v-if="detailData.state == 3"  @click="handelInputClick">录入</el-button>
                </div>
            </div>
            <div class="tableView">
                <el-table :data="tableData" style="width: 100%" :default-expand-all="isExpand">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <div v-for="(item, index) in scope.row.order_item_goods_list" :key="index" class="codeItem">
                                <div>{{ item.custom_code }}<span v-if="item.goods_type == 8">{{ item.goods_name
                                }}</span></div>
                                 <i class="el-icon-error" style="font-size: 16px;"
                                    @click="handelDeleteClick(scope.$index, index)" ></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_name" label="商品">
                    </el-table-column>
                    <el-table-column prop="sku_value" label="规格">
                    </el-table-column>
                    <el-table-column prop="unit" label="单位">
                    </el-table-column>
                    <el-table-column prop="original_price" label="标准价">
                    </el-table-column>
                    <el-table-column label="活动">
                        <template slot-scope='scope'>
                            {{ scope.row.activity_info == null ? '--' : scope.row.activity_info.activity_name }}
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠券">
                        <template slot-scope='scope'>
                            {{ scope.row.coupon_list == null ? '--' : scope.row.coupon_list.coupon_name }}
                        </template>
                    </el-table-column>
                    <el-table-column  label="优惠价" v-if="type">
                        <template slot-scope="scope">
                            <el-input placeholder="请输入优惠价" v-model="scope.row.price"  size="small">
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠价" v-else>
                        <template slot-scope='scope' >
                            {{ scope.row.price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" v-if="type">
                        <template slot-scope="scope">
                            <el-input placeholder="请输入数量" v-model="scope.row.num"  size="small">
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" v-else>
                        <template slot-scope='scope' >
                            {{ scope.row.num }}
                        </template>
                    </el-table-column>
                    <el-table-column label="退款金额">
                        <template slot-scope="scope">{{ scope.row.price * scope.row.num }}</template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" v-if="type" size="small" @click="handledelete(scope.row,scope.index)">X</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pageRightBtn">
            <el-button type="warning" v-if="detailData.state== 1" @click="handelSubmitClick">提交</el-button>
              </div>
            </div>
           
        </div>
        <div class="detailView">
            <div class="detailViewName">退货信息</div>
            <div class="detailnav">
                退货原因：{{ detailData.refund_reason == null ? '--' : detailData.refund_reason.refund_reason_detail }}
            </div>
            <div class="detailnav">
                退货描述：{{ detailData.refund_reason == null ? '--' : detailData.refund_reason.refund_reason_remak }}
            </div>
            <div v-if="detailData.refund_reason" class="detailnav" style="display: flex;">
                描述图片：
                <div v-for="item in detailData.refund_reason.refund_reason_imgs" :key="item">
                    <img :src="item" alt="" style="width: 200px;height: 200px; margin: 0 10px;">
                </div>
            </div>
        </div>
        <div class="detailView" v-if="detailData.state>1 && detailData.online_data.ship_no!=null">
            <div class="detailViewName">退货快递凭证</div>
            <div class="detailnav">
                退货方式：邮递配送
            </div>
            <div class="detailnav">
                快递公司：{{ detailData.online_data == null ? '--' : detailData.online_data.ship_name}}
            </div>
            <div class="detailnav">
                快递单号：{{ detailData.online_data == null ? '--' : detailData.online_data.ship_no }}
            </div>
            <div v-if="detailData.online_data" class="detailnav" style="display: flex;">
                快递凭证：
                <div v-for="item in detailData.online_data.ship_imgs" :key="item">
                    <img :src="item" alt="" style="width: 200px;height: 200px;margin: 0 10px;">
                </div>
            </div>
        </div>
        <el-dialog title="提示" :modal-append-to-body="false" :visible.sync="dialogconfirm_state" width="20%">
            <!--  :before-close="handleClose" -->
            <div>是否确定退货？退货后不可重复退此订单</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogconfirm_state = false">取 消</el-button>
                <el-button type="primary" @click="confirmSort">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [],
            user_info: [],
            ship_adddress: [],
            isExpand: true,
            code: '', //条码信息
            detailData: [],//录入条码信息
            id: this.$route.query.id,
            dialogconfirm_state: false, //确认退货
            check_remark: '', //拒绝说明
            type: 0,
        }
    },
    mounted() {
        this.getDetailData();
    },
    methods: {
        //提交编辑信息
        handelSubmitClick(){
          let params ={
            return_order_no:this.detailData.no,
            total_price:this.detailData.total_price,
            remark:'',
            return_item_list:this.tableData
          }
          this.$http.post(process.env.VUE_APP_AppAdmin + '/api/OrderRefund/UpdateOrderRefund', params).then((res) => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '已提交'
						});
						
                        this.getDetailData()
                         this.type=0
					}
				})
        },
        // 编辑
        handleEdit(type) {
            this.type = 1
        },
        // 删除
        handledelete(row,index) {
            this.tableData.splice(index, 1)
        },
        // 取消
        handelCancel() {
            this.$confirm('是否取消退货?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get(process.env.VUE_APP_AppAdmin +'/api/OrderRefund/ReceivedOrderRefund', {
                    order_no: this.detailData.no,
                }).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '取消成功!'
                        });
                        this.getDetailData()
                       
                    }
                })
            })
        },
        // 退款
        handelRefund() {
            this.$confirm('是否退款?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get(process.env.VUE_APP_AppAdmin +'/api/OrderRefund/OrderRefundPay', {
                    return_order_no: this.detailData.no,
                }).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '退款成功!'
                        });
                        this.getDetailData()
                    }
                })
            })
        },
        // 驳回退款
        handelTurn() {
            let params = {
                order_no: this.detailData.no,
                check_remark: this.check_remark,
                is_check: false
            }
            this.$http.post(process.env.VUE_APP_AppAdmin + '/api/OrderRefund/CheckOrderRefund', params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '审核不通过'
                    });
                    this.getDetailData()
                    this.dialogconfirm_state = false
                }
            })
        },
        // 确定录入
        handelInput() {
            let params = {
                order_no: this.detailData.no,
                order_goods_list: []
            }
            this.tableData.map(item => {
                params.order_goods_list.push({
                    order_item_id: item._id,
                    order_item_goods_list: item.order_item_goods_list
                })
            })
            this.$http.post(process.env.VUE_APP_AppAdmin + '/api/OrderRefund/AddGoodsOrderRefund', params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '录入成功'
                    });
                    this.getDetailData()
                }
            })
        },
        //删除
		handelDeleteClick(index1, index2) {
			console.log(index1, index2)
			this.tableData[index1].order_item_goods_list.splice(index2, 1);
			console.log(this.tableData)
			this.$set(this.tableData, index1, this.tableData[index1])
		},
        //录入条码
        handelInputClick() {
            let params = {
                barcode: this.code
            }
            this.$http.get(process.env.VUE_APP_Url_baseData + '/api/product/goods/from/code', params).then((res) => {
                if (res.code == 0) {

                    if (res.data.customCodeStatus.id == 9) {
                        let isOK = false;
                        let isCount = false;
                        this.tableData.map((item, index) => {
                            if (item.skus_id == res.data.skus) {
                                isOK = true;
                                if (item.order_item_goods_list == null) {
                                    item.order_item_goods_list = [];
                                }
                                if (item.order_item_goods_list.length < item.num) {
                                    isCount = true;
                                    item.code.push({
                                        code: res.data.customCode,
                                        validityStopDate: res.data.validityStopDate,
                                        costPrice: res.data.costPrice,
                                    })
                                    item.order_item_goods_list.push({
                                        goods_id: res.data.goodsId,
                                        goods_name: res.data.goodsName,
                                        model: res.data.skuValue,
                                        skus: res.data.skus,
                                        unit: res.data.unit,
                                        unit_id: res.data.unitId,
                                        goods_sales_model: 1,
                                        count: 1,
                                        validity_stop_date: res.data.validityStopDate,
                                        goods_type: res.data.goodsType,
                                        cost_price: res.data.costPrice,
                                        custom_code: res.data.customCode,
                                    })
                                    this.$set(this.tableData, index, this.tableData[index])

                                }
                            }
                        })
                        if (isOK == false) {
                            this.$message({
                                type: 'error',
                                message: '此订单不包含该条码商品'
                            });
                            return
                        }
                        if (isCount == false) {
                            this.$message({
                                type: 'error',
                                message: '条码数量超过了订单商品数量'
                            });
                            return
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: '该条码已使用'
                        });
                    }
                }
            })
        },
        // 确认退款
        handelConfirmClick() {
            this.dialogconfirm_state = true
        },
        confirmSort() {
            let params = {
                order_no: this.detailData.no,
                check_remark: '请保证商品不影响二次销售',
                is_check: true
            }
            this.$http.post(process.env.VUE_APP_AppAdmin + '/api/OrderRefund/CheckOrderRefund', params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '已通过退款申请'
                    });
                    this.getDetailData()
                    this.dialogconfirm_state = false
                }
            })

        },

        //获取详情
        getDetailData() {
            this.$http.get(process.env.VUE_APP_Url_order + '/api/OnLineOrderReturn/' + this.$route.query.id).then((res) => {
                if (res.code == 0) {
                    this.detailData = res.data;
                    this.user_info = res.data.user_info;
                    this.ship_adddress = res.data.return_item_list.ship_adddress

                    if (res.data.state == 1 || res.data.state == 2 || res.data.state == 3) {
                        res.data.return_item_list.map(item => {
                            item.order_code_list = [];
                        })
                    }
                    res.data.return_item_list.map(item => {
                        item.code = [];
                    })
                    this.tableData = res.data.return_item_list;
                }
            })
        },


    },

}
</script>

<style lang="scss" scoped>
.page {
    padding: 16px 16px 0 16px;
    height: 100%;
    box-sizing: border-box;
    .pageRightBtn {
		height: 90px;
		text-align: right;
		display: flex;
		align-items: center;
		justify-content: center;
	}
    .topView {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        background-color: #fff;
        padding: 10px 20px;

        .topViewL {
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #343440;
            font-weight: bold;
        }
    }

    .detailView {
        margin-bottom: 16px;
        padding: 24px 32px;
        background: #fff;
        border-radius: 16px;

        .detailViewName {
            font-size: 16px;
            font-weight: bold;
            color: #343440;
        }

        .detailRow {
            display: flex;
            align-items: center;
            margin-top: 32px;
            font-size: 14px;
            justify-content: space-between;

            .detailCol {
                display: flex;
                align-items: center;
                width: 24%;

                div:nth-of-type(1) {
                    width: 70px;
                    text-align: right;
                    color: #343440;
                    font-weight: 400;
                }

                div:nth-of-type(2) {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #343440;
                    font-weight: 500;
                }
            }
        }

    }

    .tableWrap {
        padding: 16px;
        background: #fff;
        border-radius: 8px;
        // height: 100%;
        display: flex;
        flex-direction: column;
        margin: 16px 0;

        .tableTitle {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            line-height: 40px;

            .tableTitleL {
                font-size: 16px;
                font-weight: bold;
                margin-left: 16px;
            }

            .tableTitleR {
                display: flex;
                align-items: center;
            }
        }

        .tableView {
            flex: 1;
            overflow-y: scroll;
            margin-top: 10px;

            .codeItem {
                // width: 146px;
                height: 32px;
                margin-left: 16px;
                background: #F7F7FA;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                float: left;
                margin-bottom: 10px;
                border-radius: 4px;
                padding: 0 10px;

                div {
                    margin-right: 10px;
                }
            }
        }
    }

    .tableView::-webkit-scrollbar {
        display: none;
    }

    .detailnav {
        line-height: 40px;
        font-size: 14px;
    }
}
</style>
